import { FC, PropsWithChildren } from 'react';
import AppDropdownMenu from '~/components/dropdown-menu';
import AppDropdownItem from '~/components/dropdown-menu/item';
import Sublink from '~/data/strapi/types/shared-components/link/sub-link';

import styles from './styles.module.css';
import HeaderSublink from './sub-link';

interface Props {
  link: Sublink;
  parentHref: string | null;
}

const DropdownSubLink: FC<PropsWithChildren<Props>> = ({ link, parentHref }) => {
  const sublinks = link.links || [];

  return (
    <AppDropdownItem>
      <AppDropdownMenu
        renderHeadComponent={(isActive) => <HeaderSublink parentHref={parentHref} data={link} isActive={isActive} />}
        listClassName={styles.dropdownList}
        horizontal
      >
        {sublinks.map((sublink, index) => {
          const currentParentHref = `${parentHref}/${link.href}`;
          return <DropdownSubLink parentHref={currentParentHref} link={sublink} key={sublink.id + '-' + index} />;
        })}
      </AppDropdownMenu>
    </AppDropdownItem>
  );
};
export default DropdownSubLink;
